import { snapMetricsSagas } from '@sagas/postCampaignReport/snapMetrics'
import { xMetricsSagas } from '@sagas/postCampaignReport/xMetrics'
import { WatcherFunction } from '..'
import { campaignMetricsSagas } from './campaignMetrics'
import { watchDownloadPostCampaignReportRequest } from './download'
import { pcrMetricsSagas } from './metrics'
import { postMetricsSagas } from './postMetrics'
import { reelMetricsSagas } from './reelMetrics'
import { storyMetricsSagas } from './storyMetrics'
import { tiktokMetricsSagas } from './tiktokMetrics'

export const postCampaignReportSagas: ReadonlyArray<WatcherFunction> = [
  ...campaignMetricsSagas,
  ...postMetricsSagas,
  ...storyMetricsSagas,
  ...tiktokMetricsSagas,
  ...reelMetricsSagas,
  ...xMetricsSagas,
  ...snapMetricsSagas,
  ...pcrMetricsSagas,
  watchDownloadPostCampaignReportRequest,
]
